export class ViewModelPergunta {
  idPessoa: number;
  idPlano: number;
  idCategoria: number;
  numeroPergunta: number;
}
